<template>
    <b-list-group>
        <b-list-group-item>
            <b-row>
                <b-col cols="12" md="5" lg="4"><div class="field-label">Escolta</div></b-col>
                <b-col cols="12" md="6" lg="6">
                    <b-row>
                        <b-col cols="12">{{ service.user.name }}</b-col>
                        <b-col cols="12">doc. {{ service.user.document }}</b-col>
                    </b-row>
                </b-col>
                <b-col cols="12" md="1" lg="2"><b-img style="max-width: 100%;" thumbnail fluid :src="service.body_guard_photo_url"></b-img></b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col cols="12" md="5" lg="4"><div class="field-label">Fecha de Inicio</div></b-col>
                <b-col cols="12" md="7" lg="8">{{ service.start_date | datetime }}</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col cols="12" md="5" lg="4"><div class="field-label">Fecha de Finalización</div></b-col>
                <b-col cols="12" md="7" lg="8">{{ service.end_date | datetime }}</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col cols="12" md="5" lg="4"><div class="field-label">Duración</div></b-col>
                <b-col cols="12" md="7" lg="8" v-if="!!service.end_date">{{ serviceDuration }} {{ serviceDuration === 1? 'hora': 'horas' }}</b-col>
                <b-col cols="12" md="7" lg="8" v-else>En curso</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col cols="12" md="5" lg="4"><div class="field-label">Tipo de Servicio</div></b-col>
                <b-col cols="12" md="7" lg="8">{{ service.type }}</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col cols="12" md="5" lg="4"><div class="field-label">{{ service.type === 'vehicular'? 'Placa': 'Documento' }}</div></b-col>
                <b-col cols="12" md="7" lg="8">{{ service.plate_document }}</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col cols="12" md="5" lg="4"><div class="field-label">{{ service.type === 'vehicular'? 'Conductor': 'Protegido' }}</div></b-col>
                <b-col cols="12" md="7" lg="8">{{ service.driver_person_name }}</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item v-if="!!service.client">
            <b-row>
                <b-col cols="12" md="5" lg="4"><div class="field-label">Cliente</div></b-col>
                <b-col cols="12" md="7" lg="8">{{ service.client.name }}</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item v-if="!!service.client_customer">
            <b-row>
                <b-col cols="12" md="5" lg="4"><div class="field-label">Sub Cliente</div></b-col>
                <b-col cols="12" md="7" lg="8">{{ service.client_customer.name }}</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col cols="12" md="5" lg="4"><div class="field-label">Fuera de la ciudad</div></b-col>
                <b-col cols="12" md="7" lg="8">{{ service.out_of_city | yesno }}</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item v-if="!!service.town">
            <b-row>
                <b-col cols="12" md="5" lg="4"><div class="field-label">Lugar</div></b-col>
                <b-col cols="12" md="7" lg="8">{{ service.town.name }}</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item>
            <b-row>
                <b-col cols="12" md="5" lg="4"><div class="field-label">Estado</div></b-col>
                <b-col cols="12" md="7" lg="8">{{ !!service.end_date? 'Finalizado': 'En Curso' }}</b-col>
            </b-row>
        </b-list-group-item>
        <b-list-group-item v-if="!!service.end_date">
            <b-row>
                <b-col cols="12">
                    <div class="field-label">Firma Cliente</div>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-img :src="service.signature_url"></b-img>
                </b-col>
            </b-row>
        </b-list-group-item>
    </b-list-group>
</template>
<script>
export default {
    name: 'bodyguard_service_general_info',
    props: {
        service: {
            type: Object,
            required: true
        }
    },
    computed: {
        serviceDuration() {
            if(!this.service.end_date) return 0;

            return Math.ceil(moment(this.service.end_date).diff(moment(this.service.start_date), 'minutes') / 60);
        }
    }
}
</script>
<style scoped>
    .field-label {
        font-weight: bold;
        color: #FF761C;
    }
</style>
